import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faUserSlash } from "@fortawesome/free-solid-svg-icons"

export const UserSlash = (props) => {
  return <FontAwesomeIcon faIcon={faUserSlash} {...props} />
}
